module.exports = __webpack_public_path__ + "img/9.c1c953f8.jpg";